import { formAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle } = createMultiStyleConfigHelpers(formAnatomy.keys);

export const fastDetailsVariant = definePartsStyle({
    container: {
        label: {
            fontWeight: '400',
            fontSize: '1.7rem',
            lineHeight: '2rem',
            color: 'general.darkBlue',
            marginBottom: '1.5rem',
        },

        input: {
            minHeight: '6.4rem',
            fontSize: '2rem',
            boxShadow:
                'inset -10px -10px 10px rgba(255, 255, 255, 0.3), inset 10px 10px 10px rgba(103, 114, 229, 0.04)',

            _placeholder: {
                color: 'rgba(0, 0, 0, 0.50)',
                fontSize: '1.6rem',
            },

            _disabled: {
                opacity: 0.75,
                background: '#d0d0d0ab',
            },
        },
    },

    helperText: {
        fontSize: '1.4rem',
        color: '#8e8ea2',
        marginBottom: '1rem',
    },
});
